import ChangeProfile from '../components/UserDetails';
import Loading from '../components/Loading';
import React from 'react';
import changeProfile from '../actions/changeProfile';
import isAuthenticated from '../actions/isAuthenticated';
import { IProfileResponse } from '../model/ProfileResponse';

export const context = 'changeUserDetails';

export class UserDetailsRoute extends React.PureComponent {
    state = {
        data: {},
        error: undefined,
        isLoading: true,
    };

    async componentDidMount() {
        try {
            const res = await isAuthenticated();
            const { data } = res as IProfileResponse;
            this.setState({ data, isLoading: false });
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    render() {
        const { isLoading, data, error } = this.state;
        if (error) {
            throw error;
        }

        if (isLoading) {
            return <Loading />;
        }

        return <ChangeProfile action={changeProfile} context={context} data={data} />;
    }
}

export default UserDetailsRoute;
